



























































































































































// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Models ---

// --- Services ---
import AuthService from '@/services/auth';

// --- Third Party imports ---

@Component
export default class CampaignCode extends Vue {
  md5 = require('md5');
  apiUrl: string = process.env.VUE_APP_API_URL;

  clicked: boolean = false;
  loader: string = '';
  costAmount: number = parseInt(process.env.VUE_APP_TEST_COST, 10);
  discountAmount: number = 0;
  totalAmount: number = 0;
  vatPercent: number = 0.15;

  headers = [
    { 
      text: 'Product', 
      value: 'product',
    },
    { 
      text: 'Total', 
      value: 'total',
    },
  ];

  items = [
    { 
      product: '', 
      total: '',
    },
  ];

  isLocal: boolean = (process.env.VUE_APP_ISLIVE === 'NO');
  paymentId: string = '';
  signature: string = '';

  // Functions

  async beforeMount() {
    const discountPercentageParam: string = (!this.$route.params.discountPercentage ? '' : this.$route.params.discountPercentage) + '';
    const discountAmountParam: string = (!this.$route.params.discountAmount ? '' : this.$route.params.discountAmount) + '';

    if (discountAmountParam && discountAmountParam.length > 0) {
      this.discountAmount = parseFloat(discountAmountParam);
    } else {
      this.discountAmount = 0;
    }

    const VAT = (this.costAmount - this.discountAmount) * this.vatPercent;
    this.totalAmount = this.costAmount - this.discountAmount + VAT;
    this.items = [];
    this.items.push(
      { 
        product: 'Online Career Evaluation', 
        total: 'R' + this.costAmount.toFixed(2),
      },
    );

    if (this.discountAmount !== 0) {
      this.items.push(
        { 
          product: 'Discount ' + ((discountPercentageParam) ? '(' + discountPercentageParam + ')' : ''), // momentum discounts wont be a percentage
          total: 'R' + this.discountAmount.toFixed(2),
        },
      );
    }
    this.items.push(
      { 
        product: 'VAT', 
        total: 'R' + VAT.toFixed(2),
      },
      { 
        product: 'Grand Total', 
        total: 'R' + this.totalAmount.toFixed(2),
      },
    );

    // NOTE: our form Purchase button will be disabled until signature has been set, which will only happen after we have the paymentId
    const response = await AuthService.createTransaction( { amount : this.totalAmount } );
    // TODO - what if createTransaction fails ?!?!
    this.paymentId = response.data.message;
    this.signature = this.generateSignature();    
  }

  cancel() {
    this.$router.push({ name: 'Campaign Code' });
  }

  purchase() {
    this.clicked = true;
    this.loader = 'clicked';
    if (this.$refs.itemForm) {
        (this.$refs.itemForm as any).submit();
      }
  }

  generateSignature() {
    // https://developers.payfast.co.za/docs#step_2_signature
    // A generated MD5 signature must be passed as an additional hidden input and this hash is then used to ensure the integrity of the data transfer.

    let signature: string = '';
    // To generate the signature:
    // 1. Concatenation of the name value pairs of all the non-blank variables with ‘&’ used as a separator
    signature += 'merchant_id=' + encodeURIComponent((this.isLocal ? '10010737' :  '11117468')).replace(/%20/g, '+');
    signature += '&merchant_key=' + encodeURIComponent((this.isLocal ? '52i2nlbhlru8e' :  '82xdrrxw3pvkj')).replace(/%20/g, '+');
    signature += '&return_url=' + encodeURIComponent(this.isLocal ? 'http://ocg-user.local:8080/payment-confirmation' :  'https://app.onlinecareerguidance.co.za/payment-confirmation').replace(/%20/g, '+');
    signature += '&cancel_url=' + encodeURIComponent(this.isLocal ? 'http://ocg-user.local:8080/register/campaign-code' :  'https://app.onlinecareerguidance.co.za/register/campaign-code').replace(/%20/g, '+');
    signature += '&notify_url=' + encodeURIComponent(this.apiUrl + '/57953A42-FD01-4276-AE23-BE926319EB5C').replace(/%20/g, '+');
    signature += '&name_first=' + encodeURIComponent(this.$store.getters['users/loggedInUser'].displayName).replace(/%20/g, '+');
    signature += '&email_address=' + encodeURIComponent(this.$store.getters['users/loggedInUser'].email).replace(/%20/g, '+');
    signature += '&m_payment_id=' + encodeURIComponent(this.paymentId).replace(/%20/g, '+');
    signature += '&amount=' + encodeURIComponent(this.totalAmount.toFixed(2)).replace(/%20/g, '+');
    signature += '&item_name=' + encodeURIComponent('Online Career Guidance Evaluation').replace(/%20/g, '+');

    //console.log(`Payment.vue - 285 - signature`, signature);

    // 2. Add your passphrase
    // NOT IN USE
    //const passphrase = 'boatymcboatface';
    //signature += '&passphrase=' + encodeURIComponent(passphrase).replace(/%20/g, '+');

    //console.log(`Payment.vue - 292 - signature`, signature);

    //signature = encodeURIComponent(signature).replace(/%20/g, '+');

    //console.log(`Payment.vue - 296 - signature`, signature);

    // 3. MD5 the parameter string and pass it as a hidden input named “signature”
    return this.md5(signature);
  }

}
